module.exports = __webpack_public_path__ + "media/images/vp/icon.switcher.on-1af0b5aae68c5eeab684b42e68194f5d.png";